import { createApiThunk } from "./thunkWrapper";

export const getAllQuizSubmissionApi = createApiThunk("quiz/getQuizSubmissions", (payload) => ({
  method: "GET",
  endPoint: "getAllQuizSubmissionApi",
  params:payload
}));
